module.exports = __webpack_public_path__ + "static/media/emotion_angry.7dfcf754.svg";